module.exports = __webpack_public_path__ + "assets/img/service-details.e8e84ea2.png";